import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {_apiBase} from "../../components/pages";
import {Consts} from "../../components/pages/consts";

const initialState = {
  accessToken: "",
  role: "",
  name: "",
  password: "",
};

// createAsyncThunk returns 3 actionCreators: pending (= auth/requestStatus/pending), fulfilled, rejected - states of the promise
// these are extra reducers (= because outside the slice
export const fetchToken = createAsyncThunk(
  'auth/fetchToken', // name space
  async () => { // a function which returns a promise for an async code (preferable). For a non-async code we need to handle errors by ourselves
    const response = await fetch(`${ _apiBase }login`, {
      method: Consts.POST,
      headers: {
        'Accept': Consts.APPLICATION_JSON,
        'Content-Type': Consts.APPLICATION_JSON
      },
      body: JSON.stringify({
        name: localStorage?.getItem(Consts.NAME),
        password: localStorage?.getItem(Consts.PASSWORD)
      })
    });

    if (!response.ok) {
      throw new Error("It was not possible to retrieve a token");
    }

    const data = await response.json();
    const {loginResponse} = data;
    return loginResponse;
  }
);

const authSlice = createSlice( // starting a function for creating a usersSlice
  {
    name: 'auth', // 1. arg: name space for the slice (unique)
    initialState: initialState, //2. arg:
    reducers: { // place for actionCreators (left)  and corresponding actions (right) - immer for immutability
      removeToken: (state) => {
        state.accessToken = null;
        localStorage?.removeItem("accessToken");
        localStorage?.removeItem(Consts.ROLE);
        localStorage?.removeItem(Consts.NAME);
        localStorage?.removeItem(Consts.PASSWORD);
      },
      setUsername: (state, action) => {
        state.name = action?.payload;
        localStorage?.setItem(Consts.NAME, action?.payload);
      },
      setPassword: (state, action) => {
        state.password = action?.payload;
        localStorage?.setItem(Consts.PASSWORD, action?.payload);
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchToken.pending, state => {
          state.tokenLoadingStatus = 'loading';
        })
        .addCase(fetchToken?.fulfilled, (state, action) => {
          state.accessToken = "bearer " + action?.payload?.token;
          state.role = action.payload.role;
          localStorage?.setItem("accessToken", "bearer " + action?.payload?.token);
          localStorage?.setItem("role", action?.payload?.role);
          state.tokenLoadingStatus = 'idle';
        })
        .addCase(fetchToken?.rejected,
          (state,
           action) => {
            state.usersLoadingStatus = action?.error?.message;
          })
        .addDefaultCase(() => {
        });
    }
  }
);

// tailor the slice in actions and reducer for putting it into the main function for creating the store
const {actions, reducer} = authSlice;
export default reducer;

export const {
  setUsername,
  setPassword,
  removeToken,
} = actions;

